$(document).ready(function() {

  $('.main-cart .table-row .total a').on('click', function() {
    const $this = $(this);
    const row = $this.closest('.table-row');
    const key = row.data('key');

    row.fadeOut(250);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates[' + key + ']=0',
      dataType: 'json',
      success: function(data) {
        let item_count = data.item_count;
        if (item_count == 0) {
          $('.main-cart .cart-items').addClass('hidden');
          $('.main-cart .no-items').removeClass('hidden');
          
          $('.header .mobile-cart-toggle span').remove();
          $('.header .menu .quick-links a.cart-icon span').remove();
        } else {
          $.each(data.items, function(k, item) {
            if (item.handle == 'large-magnetic-lid-box-sunset-mood' || item.handle == 'small-magnetic-lid-box-sunset-mood') {
              item_count = item_count - item.quantity;
            }
            
            if (item.key == key) {
              $('.total .money', row).text(Shopify.formatMoney(item.final_line_price));
            }
          });
          
          $('.header .mobile-cart-toggle span').text(item_count);
          $('.header .menu .quick-links a.cart-icon span').text(item_count);

          $('.main-cart .cart-table .table-row.gift-box').text('');
          $.ajax({
            type: 'GET', 
            url: '/cart',
            dataType: 'html',
            success: function(html) {
              var giftBoxes = $('.cart-table .table-row.gift-box', $(html));
              if (giftBoxes.length > 0) {
                $.each(giftBoxes, function(k, el) {
                  $('.main-cart .cart-table').append(el);
                });
              }
            }
          });
        }
        
        $('.main-cart .cart-summary .item-count').text(item_count);
        $('.main-cart .cart-summary .subtotal-price').text(Shopify.formatMoney(data.items_subtotal_price));
        $('.main-cart .cart-summary .total-price').text(Shopify.formatMoney(data.total_price));
      }
    });
    
    return false;
  });

  $('.main-cart .quantity button').on('click', function() {
    const $this = $(this);
    const row = $this.closest('.table-row');
    const key = row.data('key');
    const name = $this.attr('name');
    const total = $('.money', $this.closest('.total'));
    const quantity = $this.closest('.quantity');
    let qty = parseInt($('span.qty', quantity).text());

    if (name == 'plus') {
      qty = qty + 1;
    } else if (name == 'minus') {
      if (qty == 1) {
        row.fadeOut(250);
      }
      
      qty = qty - 1;
    }
    $('span.qty', quantity).text(qty);

    $('button', quantity).prop('disabled', 'disabled');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates[' + key + ']=' + qty,
      dataType: 'json',
      success: function(data) {
        let item_count = data.item_count;
        if (item_count > 0) {
          $.each(data.items, function(k, item) {
            if (item.handle == 'large-magnetic-lid-box-sunset-mood' || item.handle == 'small-magnetic-lid-box-sunset-mood') {
              item_count = item_count - item.quantity;
            }
            
            if (item.key == key) {
              $('.total .money', row).text(Shopify.formatMoney(item.final_line_price));
            }
          });

          $('.header .mobile-cart-toggle span').text(item_count);
          $('.header .menu .quick-links a.cart-icon span').text(item_count);

          $('.main-cart .cart-table .table-row.gift-box').text('');
          $.ajax({
            type: 'GET', 
            url: '/cart',
            dataType: 'html',
            success: function(html) {
              var giftBoxes = $('.cart-table .table-row.gift-box', $(html));
              if (giftBoxes.length > 0) {
                $.each(giftBoxes, function(k, el) {
                  $('.main-cart .cart-table').append(el);
                });
              }
            }
          });
        } else {
          $('.main-cart .cart-items').addClass('hidden');
          $('.main-cart .no-items').removeClass('hidden');

          $('.header .mobile-cart-toggle span').remove();
          $('.header .menu .quick-links a.cart-icon span').remove();
        }

        $('.main-cart .cart-summary .item-count').text(item_count);
        $('.main-cart .cart-summary .subtotal-price').text(Shopify.formatMoney(data.items_subtotal_price));
        $('.main-cart .cart-summary .total-price').text(Shopify.formatMoney(data.total_price));
        $('button', quantity).prop('disabled', '');
      }
    });
  });

  $('.main-cart .cart-form .promo-code a').on('click', function() {
    let promoCode = $(this).closest('.promo-code');

    promoCode.toggleClass('active');
    
    return false;
  });

  $(window).bind('pageshow', function(e) {
    if (e.originalEvent.persisted) {
      window.location.href = document.referrer;
    }
  });

  $('.main-cart .cart-form form').on('submit', function() {
    const discountCode = $('input[name="discount"]', $(this)).val();
    let button = $('button', $(this));

    $('span', button).addClass('hidden');
    $('.loading-overlay__spinner', button).removeClass('hidden');

    const giftBox = $('.table-row.gift-box');
    let items = [];
    $.each(giftBox, function(k, item) {
      const box = $(item);
      const variantId = $('.item', box).data('variant-id');
      if (variantId != undefined) {
        const quantity = parseInt($('.quantity .item .qty', box).text());
  
        items.push({
          id: variantId, 
          quantity: quantity
        });
      }
    });
      
    if (items.length > 0) {
      $.ajax({
        url: '/cart.js',
        method: 'GET',
        dataType: 'json',
        success: function(data) {
          let alreadyAdded = false;
          
          $.each(data.items, function(k, item) {
            if (item.handle == 'large-magnetic-lid-box-sunset-mood' || item.handle == 'small-magnetic-lid-box-sunset-mood') {
              alreadyAdded = true;
              
              $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: 'updates[' + item.key + ']=0',
                dataType: 'json',
                success: function(data) {
                  $.ajax({
                    url: '/cart/add.js',
                    method: 'POST',
                    data: {
                      items: items
                    },
                    dataType: 'json',
                    success: function(data) {
                      window.location.href = '/checkout' + (discountCode != '' ? '?discount=' + discountCode : '');
                    }
                  });
                }
              });
            }
          });

          if (alreadyAdded == false) {
            $.ajax({
              url: '/cart/add.js',
              method: 'POST',
              data: {
                items: items
              },
              dataType: 'json',
              success: function(data) {
                window.location.href = '/checkout' + (discountCode != '' ? '?discount=' + discountCode : '');
              }
            });
          }
        }
      });
      
      return false;
    } else if (discountCode != '') {
      window.location.href = '/checkout' + (discountCode != '' ? '?discount=' + discountCode : '');

      return false;
    }
  });
  
});
